import { Search } from "PFCore/initial_state/search";
import { createContext, useContext } from "react";

export type Dispatch = <ACTION extends object>(action: ACTION) => void | Promise<any>;

export type SearchContextStore = {
  search: Search;
};

export const SearchStoreContext = createContext<SearchContextStore>({} as SearchContextStore);
export const SearchDispatchContext = createContext<Dispatch>(() => {});

export const useSearchStoreContext = (): SearchContextStore => useContext(SearchStoreContext);
export const useSearchDispatch = (): Dispatch => useContext(SearchDispatchContext);
